import ENDPOINTS from "./endpoints";

// Códigos de report_type aceitos por /v1/reports/generated/ (POST) e usados
// como filtro em /v1/reports/generated/ (GET). Cada código corresponde a um
// dos 13 relatórios síncronos, mesma lógica de dados gerada em background.
export const REPORT_TYPES = [
    {
        value: 'patients_demographics',
        label: 'Pacientes - Demografia',
        endpoint: ENDPOINTS.REPORTS_PATIENTS_DEMOGRAPHICS,
        supportsGroupBy: false,
        supportsActiveWindowDays: false,
    },
    {
        value: 'patients_oil_types',
        label: 'Pacientes - Tipos de óleo',
        endpoint: ENDPOINTS.REPORTS_PATIENTS_OIL_TYPES,
        supportsGroupBy: false,
        supportsActiveWindowDays: false,
    },
    {
        value: 'patients_social_discounts',
        label: 'Pacientes - Desconto social',
        endpoint: ENDPOINTS.REPORTS_PATIENTS_SOCIAL_DISCOUNTS,
        supportsGroupBy: false,
        supportsActiveWindowDays: false,
    },
    {
        value: 'patients_registrations',
        label: 'Pacientes - Novos cadastros',
        endpoint: ENDPOINTS.REPORTS_PATIENTS_REGISTRATIONS,
        supportsGroupBy: true,
        supportsActiveWindowDays: false,
    },
    {
        value: 'patients_activity',
        label: 'Pacientes - Ativos x inativos',
        endpoint: ENDPOINTS.REPORTS_PATIENTS_ACTIVITY,
        supportsGroupBy: false,
        supportsActiveWindowDays: true,
    },
    {
        value: 'patients_growth',
        label: 'Pacientes - Evolução',
        endpoint: ENDPOINTS.REPORTS_PATIENTS_GROWTH,
        supportsGroupBy: false,
        supportsActiveWindowDays: true,
    },
    {
        value: 'ecommerce_products',
        label: 'Ecommerce - Produtos',
        endpoint: ENDPOINTS.REPORTS_ECOMMERCE_PRODUCTS,
        supportsGroupBy: false,
        supportsActiveWindowDays: false,
    },
    {
        value: 'ecommerce_destinations',
        label: 'Ecommerce - Destinos',
        endpoint: ENDPOINTS.REPORTS_ECOMMERCE_DESTINATIONS,
        supportsGroupBy: false,
        supportsActiveWindowDays: false,
    },
    {
        value: 'ecommerce_revenue',
        label: 'Ecommerce - Receita',
        endpoint: ENDPOINTS.REPORTS_ECOMMERCE_REVENUE,
        supportsGroupBy: true,
        supportsActiveWindowDays: false,
    },
    {
        value: 'ecommerce_discounts',
        label: 'Ecommerce - Descontos',
        endpoint: ENDPOINTS.REPORTS_ECOMMERCE_DISCOUNTS,
        supportsGroupBy: true,
        supportsActiveWindowDays: false,
    },
    {
        value: 'ecommerce_growth',
        label: 'Ecommerce - Evolução de pedidos',
        endpoint: ENDPOINTS.REPORTS_ECOMMERCE_GROWTH,
        supportsGroupBy: false,
        supportsActiveWindowDays: false,
    },
    {
        value: 'ecommerce_frequency_summary',
        label: 'Ecommerce - Frequência (resumo)',
        endpoint: ENDPOINTS.REPORTS_ECOMMERCE_FREQUENCY,
        supportsGroupBy: false,
        supportsActiveWindowDays: false,
    },
    {
        value: 'ecommerce_frequency_detail',
        label: 'Ecommerce - Frequência (detalhe)',
        endpoint: ENDPOINTS.REPORTS_ECOMMERCE_FREQUENCY_DETAIL,
        supportsGroupBy: false,
        supportsActiveWindowDays: false,
    },
];

export const REPORT_TYPE_LABELS = REPORT_TYPES.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
}, {});

export function getReportTypeLabel(value) {
    return REPORT_TYPE_LABELS[value] || value;
}

export function getReportTypeConfig(value) {
    return REPORT_TYPES.find((item) => item.value === value) || null;
}
